import * as z from 'zod';

export const languageSchema = z.object({
  locale: z.string(),
});

export type LanguageSchema = z.infer<typeof languageSchema>;
